const styles = {
  PaletteFooter: {
    backgroundColor: "#fff",
    height: " 5vh",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    fontWeight: "bold",
  },

  emoji: {
    fontSize: "1.5rem",
    margin: "1rem",
  },
};

export default styles;
